document.addEventListener('DOMContentLoaded', function() {
  const backgrounds = document.querySelectorAll('.background');
  let current = 0;

  // Verifica si hay elementos de fondo
  if (backgrounds.length === 0) {
    return; // Salir si no hay elementos
  }

  var textColorMap = {
    'Agrupación_de_Moáis.jpg': 'black',
    'Barco_Rojo_Pt._Williams.jpg': 'black',
    'Campo_de_Girasoles.jpg': 'black',
    'Cascadas_De_Petrohue.jpg': 'black',
    'Foto_del_Espacio_Ultraterrestre.jpg': 'white',
    'Lago_Torres_del_Paine.jpg': 'black',
    'Lobos_Marinos_en_Valparaíso.jpg': 'black',
    'Molinos_al_Atardecer.jpg': 'white',
    'Nubes_Sobre_Torres_del_Paine.jpg': 'black',
    'Paneles_Solares_en_el_Campo.jpg': 'white',
    'Saltos_del_Laja.jpg': 'white',
    'Silueta_de_Moái.jpg': 'black',
    'Valparaíso_de_Azul_y_Amarillo.jpg': 'black'
  };

  var photoDetails = {
    'Agrupación_de_Moáis.jpg': {
      author: 'Sophie Laurent',
      link: 'https://unsplash.com/es/fotos/formacion-rocosa-gris-bajo-nubes-blancas-y-cielo-azul-durante-el-dia-BNdjmu-wLFk'
    },
    'Barco_Rojo_Pt._Williams.jpg': {
      author: 'Carter Obasohan',
      link: 'https://unsplash.com/es/fotos/un-barco-rojo-sentado-en-la-cima-de-un-exuberante-campo-verde-h-b9_wOH8qA'
    },
    'Campo_de_Girasoles.jpg': {
      author: 'Gustavo Quepón',
      link: 'https://unsplash.com/es/fotos/campo-de-girasol-pF_2lrjWiJE'
    },
    'Cascadas_De_Petrohue.jpg': {
      author: 'Trevor Vannoy',
      link: 'https://unsplash.com/es/fotos/arboles-verdes-y-montana-de-nieve-blanca-V8y9HqtRtZs'
    },
    'Foto_del_Espacio_Ultraterrestre.jpg': {
      author: 'NASA',
      link: 'https://unsplash.com/es/fotos/foto-del-espacio-ultraterrestre-Q1p7bh3SHj8'
    },
    'Lago_Torres_del_Paine.jpg': {
      author: 'Carter Obasohan',
      link: 'https://unsplash.com/es/fotos/una-vista-de-un-lago-y-montanas-con-un-arco-iris-en-el-cielo-GhVhHMtMO08'
    },
    'Lobos_Marinos_en_Valparaíso.jpg': {
      author: 'Isabel Retamales',
      link: 'https://unsplash.com/es/fotos/focas-en-barco-blanco-y-verde-bruG--bdM-8'
    },
    'Molinos_al_Atardecer.jpg': {
      author: 'Matteo del Piano',
      link: 'https://unsplash.com/es/fotos/un-grupo-de-molinos-de-viento-en-una-colina-al-atardecer-DGqnrmdQimo'
    },
    'Nubes_Sobre_Torres_del_Paine.jpg': {
      author: 'Marc Thunis',
      link: 'https://unsplash.com/es/fotos/montana-cubierta-de-nieve-durante-el-dia-FOo-Kd7QOwA'
    },
    'Paneles_Solares_en_el_Campo.jpg': {
      author: 'Raphael Cruz',
      link: 'https://unsplash.com/es/fotos/paneles-solares-negros-en-un-campo-de-hierba-verde-durante-el-dia-IwY-27ceRCA'
    },
    'Saltos_del_Laja.jpg': {
      author: 'David Vives',
      link: 'https://unsplash.com/es/fotos/cascadas-cerca-de-arboles-verdes-bajo-nubes-blancas-durante-el-dia-dJhJ5I32uXw'
    },
    'Silueta_de_Moái.jpg': {
      author: 'Baptiste Riffard',
      link: 'https://unsplash.com/es/fotos/silueta-de-formacion-rocosa-durante-la-puesta-del-sol-k3bLH176KI0'
    },
    'Valparaíso_de_Azul_y_Amarillo.jpg': {
      author: 'Loïc Mermilliod',
      link: 'https://unsplash.com/es/fotos/landscape-photography-of-blue-and-yellow-houses-H6KJ2D0LphU'
    }
  };

  function changeBackground() {
    backgrounds[current].classList.remove('bg-active');
    current = (current + 1) % backgrounds.length;
    backgrounds[current].classList.add('bg-active');
    adjustTextColor(backgrounds[current]);
    updateFooterInfo(backgrounds[current]); // Llama a la función para actualizar el footer
  }

  function adjustTextColor(background) {
    const bgImageUrl = window.getComputedStyle(background).backgroundImage;
    const imageNameMatch = bgImageUrl.match(/url\(["']?([^"']+)["']?\)/);

    if (imageNameMatch) {
      const imageUrl = imageNameMatch[1];
      const imageName = decodeURIComponent(imageUrl.substring(imageUrl.lastIndexOf('/') + 1));
      const welcomeText = document.getElementById('welcome-text');
      welcomeText.style.color = textColorMap[imageName] || 'black';
    }
  }

  function updateFooterInfo(background) {
    const bgImageUrl = window.getComputedStyle(background).backgroundImage;
    const imageNameMatch = bgImageUrl.match(/url\(["']?([^"']+)["']?\)/);

    if (imageNameMatch) {
      const imageUrl = imageNameMatch[1];
      const imageName = decodeURIComponent(imageUrl.substring(imageUrl.lastIndexOf('/') + 1));
      const welcomeText = document.getElementById('welcome-text');
      const copyrightText = document.getElementById('copyright-text');
      const photoName = document.getElementById('photo-name');
      const photoAuthorLink = document.getElementById('photo-author-link');

      // Cambiar color del texto
      welcomeText.style.color = textColorMap[imageName] || 'black';
      copyrightText.style.color = textColorMap[imageName] || 'black';
      photoName.style.color = textColorMap[imageName] || 'black';

      // Actualizar información de la foto
      if (photoDetails[imageName]) {
        photoName.textContent = imageName.replace(/_/g, ' ').replace(/\.(jpg|png|gif)$/, '');
        photoAuthorLink.href = photoDetails[imageName].link; // Enlace del autor
        photoAuthorLink.textContent = photoDetails[imageName].author; // Nombre del autor
      } else {
        photoName.textContent = '';
        photoAuthorLink.href = '#';
        photoAuthorLink.textContent = '';
      }
    }
  }

  setInterval(changeBackground, 10000);
  adjustTextColor(backgrounds[current]);
});